import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-25" }
const _hoisted_4 = { class: "position-relative table-src-form me-0" }
const _hoisted_5 = { class: "default-table-area style-two py-15 individual-asset-performance" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle" }
const _hoisted_8 = { class: "fw-medium text-primary" }
const _hoisted_9 = { class: "text-secondary fw-medium" }
const _hoisted_10 = { class: "text-body" }
const _hoisted_11 = {
  class: "d-flex align-items-center",
  style: {"gap":"8px"}
}
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "fw-medium text-secondary fs-13" }
const _hoisted_14 = { class: "fw-normal fs-12 text-body" }
const _hoisted_15 = { class: "text-secondary" }
const _hoisted_16 = { class: "text-secondary" }
const _hoisted_17 = { class: "d-flex gap-2" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap p-4",
  style: {"padding-top":"15px !important"}
}
const _hoisted_22 = { class: "fs-13" }
const _hoisted_23 = { "aria-label": "Page navigation example" }
const _hoisted_24 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_25 = { class: "page-item" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "page-item" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  class: "modal fade",
  id: "exampleModal2",
  tabindex: "-1",
  "aria-labelledby": "exampleModal2Label",
  "aria-hidden": "true"
}
const _hoisted_31 = {
  class: "modal-dialog modal-dialog-centered",
  style: {"max-width":"550px"}
}
const _hoisted_32 = { class: "modal-content rounded-0" }
const _hoisted_33 = { class: "modal-header border-0 p-4 border-bottom" }
const _hoisted_34 = {
  class: "modal-title fs-18",
  id: "exampleModal2Label"
}
const _hoisted_35 = { class: "modal-body p-4" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-lg-6" }
const _hoisted_38 = { class: "form-group mb-4" }
const _hoisted_39 = { class: "col-lg-6" }
const _hoisted_40 = { class: "form-group mb-4" }
const _hoisted_41 = { class: "col-lg-6" }
const _hoisted_42 = { class: "form-group mb-4" }
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "col-lg-6" }
const _hoisted_45 = { class: "form-group mb-4" }
const _hoisted_46 = { class: "col-lg-6" }
const _hoisted_47 = { class: "form-group mb-4" }
const _hoisted_48 = { class: "col-lg-6" }
const _hoisted_49 = { class: "form-group mb-4" }
const _hoisted_50 = { class: "col-lg-12" }
const _hoisted_51 = { class: "d-flex justify-content-end flex-wrap gap-3" }
const _hoisted_52 = {
  type: "submit",
  class: "btn btn-primary py-2 px-4 fw-medium fs-16",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            type: "text",
            class: "form-control border-0",
            placeholder: "Search here....",
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterWallets && _ctx.filterWallets(...args)))
          }, null, 544), [
            [_vModelText, _ctx.searchQuery]
          ]),
          _cache[14] || (_cache[14] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y text-secondary" }, " search ", -1))
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline-primary fw-medium rounded-3 hover-bg",
          "data-bs-toggle": "modal",
          "data-bs-target": "#exampleModal2",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
        }, [...(_cache[15] || (_cache[15] = [
          _createElementVNode("span", {
            class: "d-flex align-items-center",
            style: {"gap":"5px"}
          }, [
            _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block fs-20 lh-1" }),
            _createElementVNode("span", null, "Add Wallet")
          ], -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Name"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Address"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Crypto Asset"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Balance"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, " Last Transaction Date "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Status"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Actions")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedWallets, (wallet) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: wallet.id
                }, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(wallet.name), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.shortenAddress(wallet.address)), 1),
                  _createElementVNode("td", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("img", {
                        src: _ctx.getAssetImage(wallet.asset),
                        style: {"max-width":"22px"},
                        alt: wallet.asset
                      }, null, 8, _hoisted_12),
                      _createElementVNode("span", _hoisted_13, [
                        _createTextVNode(_toDisplayString(_ctx.getAssetName(wallet.asset)) + " ", 1),
                        _createElementVNode("span", _hoisted_14, " (" + _toDisplayString(wallet.asset) + ") ", 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(wallet.balance) + " " + _toDisplayString(wallet.asset), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.formatDate(wallet.lastTransaction)), 1),
                  _createElementVNode("td", {
                    class: _normalizeClass(
                    wallet.status === 'Active'
                      ? 'text-success'
                      : 'text-danger-80'
                  )
                  }, _toDisplayString(wallet.status), 3),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-outline-secondary",
                        onClick: ($event: any) => (_ctx.editWallet(wallet)),
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#exampleModal2"
                      }, [...(_cache[16] || (_cache[16] = [
                        _createElementVNode("i", { class: "ri-edit-line" }, null, -1)
                      ]))], 8, _hoisted_18),
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-outline-danger",
                        onClick: ($event: any) => (_ctx.confirmDelete(wallet.id))
                      }, [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("i", { class: "ri-delete-bin-line" }, null, -1)
                      ]))], 8, _hoisted_19)
                    ])
                  ])
                ]))
              }), 128)),
              (_ctx.filteredWallets.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("td", {
                      colspan: "7",
                      class: "text-center py-4 text-secondary"
                    }, " No wallets found ", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("span", _hoisted_22, " Showing " + _toDisplayString(_ctx.showingStart) + "-" + _toDisplayString(_ctx.showingEnd) + " of " + _toDisplayString(_ctx.filteredWallets.length) + " results ", 1),
          _createElementVNode("nav", _hoisted_23, [
            _createElementVNode("ul", _hoisted_24, [
              _createElementVNode("li", _hoisted_25, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Previous",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                  disabled: _ctx.currentPage === 1
                }, [...(_cache[20] || (_cache[20] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))], 8, _hoisted_26)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "page-item",
                  key: page
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["page-link", { active: page === _ctx.currentPage }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_27)
                ]))
              }), 128)),
              _createElementVNode("li", _hoisted_28, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Next",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                  disabled: _ctx.currentPage === _ctx.totalPages
                }, [...(_cache[21] || (_cache[21] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))], 8, _hoisted_29)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("h1", _hoisted_34, _toDisplayString(_ctx.isEditing ? "Edit Wallet" : "Add New Wallet"), 1),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close campaigns-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
              })
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("form", {
                onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _cache[22] || (_cache[22] = _createElementVNode("label", { class: "label text-secondary" }, "Wallet Name", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.name) = $event)),
                        type: "text",
                        class: "form-control h-60 border-border-color",
                        placeholder: "Enter Wallet Name",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.form.name]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", { class: "label text-secondary" }, "Wallet Address", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.address) = $event)),
                        type: "text",
                        class: "form-control h-60 border-border-color",
                        placeholder: "Enter Wallet Address",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.form.address]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _cache[25] || (_cache[25] = _createElementVNode("label", { class: "label text-secondary" }, "Crypto Asset", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.asset) = $event)),
                        class: "form-select form-control h-60 border-border-color",
                        required: ""
                      }, [
                        _cache[24] || (_cache[24] = _createElementVNode("option", { value: "" }, "Select Asset", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cryptoAssets, (asset) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: asset.symbol,
                            value: asset.symbol
                          }, _toDisplayString(asset.name) + " (" + _toDisplayString(asset.symbol) + ") ", 9, _hoisted_43))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.form.asset]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _cache[26] || (_cache[26] = _createElementVNode("label", { class: "label text-secondary" }, "Balance", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.balance) = $event)),
                        type: "number",
                        step: "0.00000001",
                        class: "form-control h-60 border-border-color",
                        placeholder: "Enter Balance",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.form.balance]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _cache[27] || (_cache[27] = _createElementVNode("label", { class: "label text-secondary" }, "Last Transaction Date", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.lastTransaction) = $event)),
                        type: "date",
                        class: "form-control h-60 border-border-color",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.form.lastTransaction]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _cache[29] || (_cache[29] = _createElementVNode("label", { class: "label text-secondary" }, "Status", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.status) = $event)),
                        class: "form-select form-control h-60",
                        required: ""
                      }, [...(_cache[28] || (_cache[28] = [
                        _createElementVNode("option", { value: "Active" }, "Active", -1),
                        _createElementVNode("option", { value: "Inactive" }, "Inactive", -1)
                      ]))], 512), [
                        [_vModelSelect, _ctx.form.status]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger py-2 px-4 fw-medium fs-16 text-white",
                        "data-bs-dismiss": "modal",
                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
                      }, " Cancel "),
                      _createElementVNode("button", _hoisted_52, [
                        _cache[30] || (_cache[30] = _createElementVNode("i", { class: "ri-add-line text-white fw-medium" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.isEditing ? "Update" : "Create"), 1)
                      ])
                    ])
                  ])
                ])
              ], 32)
            ])
          ])
        ])
      ])
    ])
  ]))
}